{
  "brand": "VBB PLAY",
  "tagline": "Премиум ойын платформасы",
  "loading": "Жүктелуде…",
  "retry": "Қайта көру",
  "close": "Жабу",
  "search": "Іздеу",
  "seeAll": "Барлығын көру",
  "comingSoon": "Жақында",
  "currency": "AZN",
  "language": "Тіл",
  "selectLanguage": "Тілді таңдаңыз",
  "offlineHint": "Байланыс тексерілуде",
  "footerRights": "© {{year}} VBB PLAY. Барлық құқықтар қорғалған.",
  "footerSupport": "Қолдау",
  "heroEyebrow": "PLAY BEYOND LIMITS",
  "heroTitle": "Үлкен ойындар. Батыл ұтыстар.",
  "heroSubtitle": "Шектен шығыңыз — премиум лобби, қауіпсіз касса және таңдалған ойын каталогы.",
  "heroCta": "Қазір ойнау",
  "promoFallbackTitle": "VBB PLAY бонус клубы",
  "promoFallbackSubtitle": "Бонус және VIP бағдарламасы дайындалуда. Хабарландырулар жақында қолжетімді болады.",
  "promoFallbackCta": "Жақында",
  "login": "Кіру",
  "promoFilter_all": "All",
  "promoFilter_welcome": "Welcome",
  "promoFilter_casino": "Casino",
  "promoFilter_sports": "Sports",
  "promoFilter_vip": "VIP",
  "storyBonuses": "Бонустар",
  "storyVip": "VIP",
  "storyCashback": "Кэшбэк",
  "storyCrypto": "Крипто",
  "bonusSelectTitle": "Бонус таңдау",
  "continue": "Жалғастыру",
  "supportWelcome": "VBB PLAY-ге қош келдіңіз",
  "supportPrechat": "Диалогты бастамас бұрын байланыс пен сұрақты енгізіңіз.",
  "supportEmail": "Email",
  "supportName": "Аты",
  "supportMessage": "Хабарлама",
  "supportConsent": "Жеке деректерді өңдеуге келісемін.",
  "startDialogue": "Диалогты бастау",
  "attach": "Тіркеу",
  "send": "Жіберу",
  "support247": "Қолдау 24/7",
  "supportInvite": "Операторлар көмектесуге дайын.",
  "contactSupport": "Қолдаумен байланысу",
  "infoSection": "Ақпарат",
  "referral": "Реферал",
  "liveSports": "Тікелей",
  "prematch": "Прематч",
  "fiatMethods": "Фиат",
  "fiatMethodsHint": "Карта, M10, Терминал",
  "cryptoMethodsHint": "Кассадағы қолдау көрсетілетін криптовалюталар",
  "personalInfo": "Жеке мәліметтер",
  "contactInfo": "Байланыс",
  "displayName": "Аты",
  "notAvailable": "Қолжетімсіз",
  "phone": "Телефон",
  "profileEditHint": "Аты, туған күні және жынысы аккаунтта сақталады.",
  "myProfile": "Профилім",
  "securitySettings": "Қауіпсіздік",
  "rewardCenter": "Марапат орталығы",
  "notificationsTitle": "Хабарламалар",
  "markAllRead": "Барлығын оқылды ету",
  "marketingOptIn": "Промо хабарламалар алу",
  "emptyNotifications": "Хабарлама жоқ",
  "notificationsUnavailable": "Оқиға хабарламалары осында көрінеді.",
  "open": "Ашу",
  "protectionTitle": "Аккаунт қорғауы",
  "coolingOff": "Салқындау мерзімі",
  "selfExclude": "Өзін шектеу",
  "requestClosure": "Аккаунтты жабуды сұрау",
  "helpSupport": "Көмек және қолдау",
  "promoCode": "Промокод",
  "redeem": "Іске қосу",
  "bonusHistory": "Бонус тарихы",
  "promoLoginRequired": "Кодты іске қосу үшін кіріңіз.",
  "promoSuccess": "{{amount}} AZN есептелді",
  "promo_invalid_code": "Бұл код жарамсыз.",
  "promo_campaign_expired": "Науқан мерзімі өтті.",
  "promo_campaign_inactive": "Науқан белсенді емес.",
  "promo_campaign_not_started": "Науқан әлі басталған жоқ.",
  "promo_per_user_limit": "Сіз бұл кодты бұрын қолдандыңыз.",
  "promo_unique_user_limit": "Науқанның ойыншы шегі толды.",
  "promo_usage_limit": "Бұл науқан бойынша іске қосу қалмады.",
  "promo_not_eligible": "Сіз бұл науқанға жарамайсыз.",
  "promo_minimum_deposit_not_satisfied": "Сәйкес депозит қажет.",
  "promo_budget_exhausted": "Науқан бюджеті таусылды.",
  "promo_too_many_requests": "Тым көп әрекет. Кейінірек көріңіз.",
  "promo_zero_reward": "Бұл науқанның мұнда ақшалай сыйлығы жоқ.",
  "promo_redeem_failed": "Кодты іске қосу мүмкін болмады.",
  "storyPromo": "Промокод",
  "liveSupport": "Тікелей қолдау",
  "sportsUnavailable": "Спорт ставкалары әзірге қолжетімсіз. Казино ашық.",
  "linked": "Қосылған",
  "notLinked": "Қосылмаған",
  "loadFailed": "Жүктелмеді",
  "unavailableTitle": "Қолжетімсіз",
  "vipUnavailable": "VIP деңгейлері әлі бапталмаған.",
  "givenName": "Аты",
  "familyName": "Тегі",
  "dateOfBirth": "Туған күні",
  "gender": "Жынысы",
  "genderMale": "Ер",
  "genderFemale": "Әйел",
  "genderOther": "Басқа",
  "genderPreferNot": "Айтқым келмейді",
  "saveProfile": "Профильді сақтау",
  "profileSaved": "Профиль сақталды",
  "profileSaveFailed": "Профиль сақталмады",
  "identityLockedNotice": "Жеке деректеріңіз сақталған. Өзгерту үшін тікелей қолдауға хабарласыңыз.",
  "identityChangeRequest": "Өзгерту сұрау",
  "identityChangeReason": "Өзгерту себебі",
  "identitySubmitRequest": "Сұрауды жіберу",
  "identityChangePending": "Сұрауыңыз қаралуда.",
  "identityChangeSubmitted": "Сұрау жіберілді. Тікелей қолдау хабарласады.",
  "identityChangeFailed": "Сұрау жіберілмеді.",
  "identityNoChanges": "Сұрайтын өзгеріс жоқ.",
  "createdAt": "Тіркелген күні",
  "ageIneligible": "Бұл туған күн заңды жастан төмен. Нақты ақша ойыны өшірулі қалады.",
  "rateOperator": "Сұхбатты бағалаңыз",
  "ratingComment": "Пікір (міндетті емес)",
  "submitRating": "Баға жіберу",
  "ratingThanks": "Бағаңыз үшін рахмет",
  "footerRules": "Ережелер",
  "footerPrivacy": "Құпиялылық",
  "rulesLink": "Ережелер мен саясаттар",
  "footerLegalTitle": "Заңды ақпарат",
  "footerLegalDraftBadge": "ЖОБА",
  "footerLegalDraftNotice": "Төмендегі деректер тек жергілікті заң жобасы ретінде берілген. Компания тіркеуі мен лицензия расталғанға дейін олардың тексерілгені, VBB PLAY лицензияланғаны немесе барлық құмар ойын қызметін заңды жүргізу өкілеттігі бар екені мәлімделмейді.",
  "footerCompanyLabel": "Компания",
  "footerCompanyName": "Vbb Play Byte Lab Sociedad de Responsabilidad Limitada",
  "footerCountryLabel": "Тіркеу елі",
  "footerCountryValue": "Коста-Рика",
  "footerRegNumberLabel": "Тіркеу нөмірі",
  "footerRegNumberValue": "2-101-918934",
  "footerAddressLabel": "Заңды мекенжай",
  "footerAddressValue": "Provincia 04 San Jose, Canton 02 Escazu, San Rafael, Multiplaza de Escazu кинотеатрларынан 200 метр оңтүстікке, Seiba көшесі, Centro Corporativo EBC, оныншы қабат, Invicta Legal кеңсесі.",
  "footerLicenseNumberLabel": "Ұсынылған лицензия нөмірі",
  "footerLicenseNumberValue": "ALSI-207508070-FI1",
  "footerLicenseJurisdictionLabel": "Ұсынылған лицензия юрисдикциясы",
  "footerLicenseJurisdictionValue": "Анжуан, Комор Аралдары Одағы",
  "footerLegalAria": "Заңды ақпарат",
  "footerLegalStatement": "© 2026 VBB Play. vbbplay.com Kosta-Rikada qeydiyyatdan keçmiş Vbb PLay Byte Lab Sociedad de Responsabilidad Limitada şirkətinə məxsusdur və onun tərəfindən idarə olunur, qeydiyyat nömrəsi 2-101-918934, hüquqi ünvanı: Provincia 04 San Jose, Canton 02 Escazu, San Rafael, Multiplaza de Escazu kinoteatrlarından 200 metr cənubda, Seiba küçəsi, Centro Corporativo EBC, onuncu mərtəbə, Invicta Legal ofisi. vbbplay.com Komor Adaları İttifaqının Avtonom Anjuan Adası Hökuməti tərəfindən lisenziyalaşdırılıb və tənzimlənir və ALSI-207508070-FI1 nömrəli lisenziya əsasında fəaliyyət göstərir. VbbPlay.com bütün tənzimləyici tələblərdən keçmişdir və hər cür qumar oyunları və mərc əməliyyatlarını qanuni şəkildə həyata keçirməyə səlahiyyətlidir.",
  "back": "Артқа",
  "rulesSelectAria": "Құқықтық құжатты таңдаңыз",
  "scrollToTop": "Жоғарыға",
  "footerAria": "Сайт төменгі бөлігі",
  "footerLiveCasino": "Тікелей казино",
  "footerProviders": "Провайдерлер",
  "footerFastGames": "Жылдам ойындар",
  "footerEsports": "Киберспорт",
  "footerTournaments": "Турнирлер",
  "footerPartnership": "Серіктестік бағдарламасы",
  "footerTechSupport": "Техникалық қолдау",
  "footerSupportSecurity": "Қолдау және қауіпсіздік",
  "footerSocial": "Әлеуметтік желілер",
  "footerSocialPending": "Ресми әлеуметтік аккаунттар расталғаннан кейін осында ашылады.",
  "footerAgeHint": "Тек 18+",
  "footerLegalAccordionTitle": "Заңды ақпарат"
}
